import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconClockSnooze: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="clock-snooze, timer, snooze, zz"><path d="M12 7.75V12L14.5 14.5M16 3.65722C14.7894 3.07575 13.4328 2.75 12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 11.2227 21.1541 10.4678 20.9736 9.74653M18.75 1.75H22.25V2.03125L18.75 5.96875V6.25H22.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconClockSnooze;
